class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      if (window.infinitescroll) window.infinitescroll.init();
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    cartDrawerUpdatee();
    const filterbtn = this.querySelectorAll('.filter-button');
    const showbtn = this.querySelector('.show-button');
    const sortbtn = this.querySelector('.sort-button');
    const preventScroll = (e) => {
      if (window.innerWidth <= 991 && document.querySelector('body').classList.contains('open-filter')) {
        e.preventDefault();
      }
    };
    if(filterbtn){
      filterbtn.forEach((filterButton) => {
        filterButton.addEventListener('click',function(e){
          e.preventDefault();
          document.querySelector('body').classList.toggle('open-filter');
          document.querySelector('body').classList.remove('open-sort','open-drawer','open-menu','open-search');
        });
      })
    }
    if (showbtn) showbtn.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-filter');
    });
    if (sortbtn) sortbtn.addEventListener('click',function(e){
      document.querySelector('body').classList.toggle('open-sort');
      document.querySelector('body').classList.remove('open-filter','open-drawer','open-menu','open-search');
    });
    if(document.querySelector('.sort-box')){
      this.querySelector('.sort-box').addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
      if (window.innerWidth > 991) {
        document.addEventListener('touchmove', preventScroll, { passive: false });
        document.addEventListener('wheel', preventScroll, { passive: false }); 
      }
    }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
      FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    cartDrawerUpdatee();
    window.scrollTo(0, 0);
  }
  static renderSectionFromFetch(url, event) {
      fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        
        FacetFiltersForm.renderProductGridContainer(html);
        //FacetFiltersForm.renderActiveFilter(html);
        if (window.infinitescroll) window.infinitescroll.init();
        if(typeof quickAddButton == 'function'){
          quickAddButton();
        }
      });
    }
    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      //FacetFiltersForm.renderActiveFilter(html);
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
    }
    static renderProductGridContainer(html) {
      document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
    }
    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const facetDetailsElements = parsedHTML.querySelectorAll('.filter-index');
      const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.filter-index') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    let count = 0;
    document.querySelectorAll('.filter-index').forEach((filter) => {
      if(filter.classList.contains('facet-list')){
        filter.querySelectorAll('ul li input[type="checkbox"]:checked').forEach((index,list) => {
          count++;
        });
      }
    });  

    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    facetsToRender.forEach((element) => {
      document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('collection-grid').dataset.id,
      }
    ]
  }
  onSubmitHandler(event) {
    const filterCheck=(params)=>{
      let available = params.match(/filter/g)
      if(available === null){
        available = 0
      }else{
        available = available.length
      }
      return available
    }
    event.preventDefault();
    let formData = new FormData(event.target.closest('form'));
    let searchParams = new URLSearchParams(formData).toString();

    const result = filterCheck(searchParams)
    if(!(searchParams.includes("availability"))){
      if(result > 0){
        searchParams = "filter.v.availability=1&" + searchParams;
      }
    }else if (result < 2){
      searchParams = searchParams.replace("filter.v.availability=1&", "");
    }
    FacetFiltersForm.renderPage(searchParams, event);
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
function filterprice(){
  var inputLeft = document.querySelector(".price-left");
  var inputRight = document.querySelector(".price-right");
  var amountLeft = document.querySelector(".amount-left .amount-percentage");
  var amountRight = document.querySelector(".amount-right .amount-percentage");
  var thumbLeft = document.querySelector(".price-slider > .thumb.left");
  var thumbRight = document.querySelector(".price-slider > .thumb.right");
  var range = document.querySelector(".price-slider > .range");
  function setLeftValue() {
    var _this = inputLeft,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.min(parseInt(_this.value), parseInt(inputRight.value) - 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbLeft.style.left = percent + "%";
    amountLeft.innerHTML = _this.value;
    range.style.left = percent + "%";
  }
  setLeftValue();
  function setRightValue() {
    var _this = inputRight,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.max(parseInt(_this.value), parseInt(inputLeft.value) + 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbRight.style.right = (100 - percent) + "%";
    amountRight.innerHTML = _this.value;
    range.style.right = (100 - percent) + "%";
    _this.style.zIndex  = 3;    
  }
  setRightValue();
  inputLeft.addEventListener("input", setLeftValue);
  inputRight.addEventListener("input", setRightValue);
}
if(document.querySelector('.range-wrap')){
  filterprice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="no-browser";
  }
  document.getElementById('MainContent').classList.add(browserName);
}
fnBrowserDetect()
if(localStorage.getItem("collDeskGrid") == null){
  localStorage.setItem("collDeskGrid", document.querySelector(".coll-desk-grid li.active a").textContent);
}else{
  document.querySelector(".collection-grid").setAttribute('data-desk',localStorage.getItem("collDeskGrid"));
  if(document.querySelector(".coll-desk-grid li.active a").textContent != localStorage.getItem("collDeskGrid")){
    document.querySelector(".coll-desk-grid li.active").classList.remove('active')
    let deskGrids = document.querySelectorAll(".coll-desk-grid li a");
    deskGrids.forEach((deskGrid) => {
        let desk_val = deskGrid.textContent
        if(parseInt(desk_val) == parseInt(localStorage.getItem("collDeskGrid"))){
            deskGrid.closest('li').classList.add('active')
        }
    });
  }
}
if(localStorage.getItem("collMobGrid") == null){
  localStorage.setItem("collMobGrid", document.querySelector(".coll-mb-grid li.active a").textContent);
}else{
  document.querySelector(".collection-grid").setAttribute('data-mb',localStorage.getItem("collMobGrid"));
  

  
  if(document.querySelector(".coll-mb-grid li.active a").textContent != localStorage.getItem("collMobGrid")){
    
    document.querySelector(".coll-mb-grid li.active").classList.remove('active')
    let mbGrids = document.querySelectorAll(".coll-mb-grid li a");
    mbGrids.forEach((mbGrid) => {
        let mb_val = mbGrid.textContent
        if(parseInt(mb_val) == parseInt(localStorage.getItem("collMobGrid"))){
            mbGrid.closest('li').classList.add('active')
        }
    });
  }
}

if(document.querySelectorAll('.coll-desk-grid a') != null){
  document.querySelectorAll('.coll-desk-grid a').forEach((grid) => {
    grid.addEventListener('click',function(e){
      e.preventDefault();
      localStorage.setItem("collDeskGrid", grid.textContent);
      document.querySelector(".collection-grid").setAttribute('data-desk',localStorage.getItem("collDeskGrid"));

  if (localStorage.getItem("collMobGrid") === '1' ) {
    document.querySelector(".snippet-collection-filter").classList.add('hide-view')
  } else {
    document.querySelector(".snippet-collection-filter").classList.remove('hide-view')
  } 
      
      const desk_grids = document.querySelectorAll(".coll-desk-grid li.active");
      desk_grids.forEach((desk_grid) => {
        desk_grid.classList.remove("active");
      });
      grid.closest('li').classList.add("active");
    });
  });
}
if(document.querySelectorAll('.coll-mb-grid a') != null){
  document.querySelectorAll('.coll-mb-grid a').forEach((grid) => {
    grid.addEventListener('click',function(e){
      e.preventDefault();
      localStorage.setItem("collMobGrid", grid.textContent);
      document.querySelector(".collection-grid").setAttribute('data-mb',localStorage.getItem("collMobGrid"));

  if (localStorage.getItem("collMobGrid") === '1' ) {
    document.querySelector(".snippet-collection-filter").classList.add('hide-view')
  } else {
    document.querySelector(".snippet-collection-filter").classList.remove('hide-view')
  } 
      
      const desk_grids = document.querySelectorAll(".coll-mb-grid li.active");
      desk_grids.forEach((desk_grid) => {
        desk_grid.classList.remove("active");
      });
      grid.closest('li').classList.add("active");
      document.querySelector('body').classList.remove("open-view");
    });
  });
}


const gridcheck = () => {
const grid = localStorage.getItem("collMobGrid")
  if (grid === '1' ) {
    document.querySelector(".snippet-collection-filter").classList.add('hide-view')
  }  
}
gridcheck()


document.addEventListener("scroll", (event) => {
  const footerTop = Math.abs(window.innerHeight - document.querySelector('.top-footer.grid').offsetTop)
  const filterBar = document.querySelector('.snippet-collection-filter')

  if (window.scrollY > footerTop) {
    filterBar.classList.add('hide-bar')
  } else {
    filterBar.classList.remove('hide-bar')
  }
})


function cartDrawerUpdatee() {
  var url = window.location.href;
  fetch(url)
    .then(response => response.text())
    .then(html => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      if (doc.querySelector('#collection_pro_count') != null) {
       var mainSectionContent = doc.querySelector('#collection_pro_count').innerHTML;
       document.querySelector('#collection_pro_count').innerHTML = mainSectionContent;
      }
      var newCounts = doc.querySelectorAll('.filter-row');
      var currentCounts = document.querySelectorAll('.filter-row');

      if (newCounts.length && currentCounts.length) {
        currentCounts.forEach((el, index) => {
          if (newCounts[index]) {
            el.innerHTML = newCounts[index].innerHTML;
          }
        });
      }
      var newFacetTitles = doc.querySelectorAll('.facet-title');
      var currentFacetTitles = document.querySelectorAll('.facet-title');

      if (newFacetTitles.length && currentFacetTitles.length) {
        currentFacetTitles.forEach((el, index) => {
          if (newFacetTitles[index]) {
            el.innerHTML = newFacetTitles[index].innerHTML;
          }
        });
      }
    })
    .catch(error => {
      console.error('Error fetching collection main section:', error);
    });

}







